import { render, staticRenderFns } from "./MesaSalaoMapa.vue?vue&type=template&id=88b9d438&scoped=true"
import script from "./MesaSalaoMapa.vue?vue&type=script&lang=js"
export * from "./MesaSalaoMapa.vue?vue&type=script&lang=js"
import style0 from "./MesaSalaoMapa.vue?vue&type=style&index=0&id=88b9d438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b9d438",
  null
  
)

export default component.exports